import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import utils from '@utils';

export const changePassword = async (
  value: any,
  formikHelpers: FormikHelpers<any>,
  handleCloseModal: any
) => {
  formikHelpers.setSubmitting(true);
  try {
    await utils.amplify.changePassword(value.currentPassword, value.password);
    formikHelpers.setSubmitting(false);

    handleCloseModal(false);
    notify('パスワードの変更に成功しました', 'success');
    // モーダルを閉じる
  } catch (err) {
    switch (err.code) {
      case 'NotAuthorizedException': {
        notify('現在のパスワードに間違いがあります', 'error');
        break;
      }
      default: {
        notify('パスワードの変更に失敗しました', 'error');
        break;
      }
    }
    formikHelpers.setSubmitting(false);
  }
};
